import AudioManager from "../../Shared/AudioManager";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import {Global} from "../../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskShareImage extends cc.Component {

    @property(cc.Label)
    labHttp: cc.Label = null;
    @property(cc.Button)
    btnSubmit: cc.Button = null;
    @property(cc.Node)
    tips1: cc.Node = null;
    @property(cc.Node)
    tips2: cc.Node = null;
    @property(cc.Node)
    button1: cc.Node = null;
    @property(cc.Node)
    button2: cc.Node = null;
    strUrl = "";
    shareDatumType = 0;
    start () {

    }

    updateUI(list){

        this.labHttp.string = "上传图片";
        this.btnSubmit.clickEvents[0].customEventData = list.id ;

    }

    onBtnClose(event,param) {
        AudioManager.playSound("close")
        this.node.active = false;
    }

    // onToggleImage(){
    //     this.tips1.active = true;
    //     this.tips2.active = false;
    //     this.button1.active = true;
    //     this.button2.active = false;
    // }
    //
    // onToggleVideo(){
    //     this.tips1.active = false;
    //     this.tips2.active = true;
    //     this.button1.active = false;
    //     this.button2.active = true;
    // }

    onBtnUploadImage(event,param){
        Utils.pickImageFromAlbum("image",function (path:string) {
            cc.log("=====打开相册的path",path);
            cc.log(path);
            let sts = path.split("/");
            let fileName =  sts[sts.length -1];
            let size = jsb.fileUtils.getFileSize(path);
            // if (size >= 1024*1024){
            //     UIManager.hideLoadingUI();
            //     UIManager.showToastUI("上传图片大小不能超过1M");
            //     return;
            // }
            UIManager.showLoadingUI();
            NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path),function (rec) {
                console.log("=====上传照片之后返回",rec.path);
                UIManager.hideLoadingUI();
                this.strUrl = rec.path;
                this.shareDatumType = 0;
                this.labHttp.string = this.strUrl;
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                cc.log("====照片上传错误");
            }.bind(this))

        }.bind(this));
    }

    // onBtnUploadVideo(event,param){
    //     Utils.pickImageFromAlbum("video",function (path:string) {
    //         cc.log("=====打开视频的path",path);
    //         cc.log(path);
    //         let sts = path.split("/");
    //         let fileName =  sts[sts.length -1];
    //         let size = jsb.fileUtils.getFileSize(path);
    //         if (size > 1024*1024 *2){
    //             UIManager.hideLoadingUI();
    //             UIManager.showToastUI("上传图片大小不能超过2M");
    //             return;
    //         }
    //
    //         UIManager.showLoadingUI();
    //         NetworkLogic.uploadFile(fileName, jsb.fileUtils.getDataFromFile(path),function (rec) {
    //             console.log("=====上传视频之后返回",rec);
    //             UIManager.hideLoadingUI();
    //             this.strUrl = rec.path;
    //             this.shareDatumType = 1;
    //             this.labHttp.string = this.strUrl;
    //         }.bind(this),function () {
    //             UIManager.hideLoadingUI();
    //             cc.log("====照片视频错误");
    //         }.bind(this))
    //
    //     }.bind(this));
    //
    // }

    onBtnSubmit(event,param){
        AudioManager.playSound("button");
        if (!this.strUrl){
            UIManager.showToastUI("请先上传资料!",Global.ToastType.Warnning);
            return;
        }
        let index = this.strUrl.lastIndexOf(".");
        let suffix = this.strUrl.substr(index+1);
        cc.log("==suffix:",suffix);
        if (suffix != "png" && suffix != "jpeg" && suffix != "jpg"){
            UIManager.showToastUI("请先上传正确格式的图片!",Global.ToastType.Warnning);
            return;
        }
        cc.log("====strUrl:",this.strUrl);
        let data = {
            shareDatum:this.strUrl,
            shareDatumType:this.shareDatumType
        }
        UIManager.showLoadingUI();
        NetworkLogic.taskAuditShare(data,function (rec) {
            UIManager.hideLoadingUI();
            cc.log("==== 提交资料成功 rec:",JSON.stringify(rec));
            cc.director.emit(Global.UserEvent.UpdateShareTaskBtn,rec)
            this.node.destroy();
            UIManager.showTipUI("提交申请成功，请等待审核");
        }.bind(this),function () {
            console.log("=====提交错误")
        })
    }

}
